import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AppHttpService {
  private httpClient = inject(HttpClient);

  private baseUrl = `${environment.cmiApiUri}`;

  getCompanyLogo(): Observable<Blob> {
    const url = `${this.baseUrl}/api/file/logo`;

    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
